<template>
    <b-tab title="Required Documents Check">
        <div class="row border-bottom mb-3" >
            <div class="col-12">
                <div class="mb-2 float-right">
                    <div class="row">
                        <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                            <div class="btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-justified" role="group">
                                    <div class="btn-group" role="group">
                                        <button id="refresh" class="btn btn-primary" data-original-title="Refresh" @click="refresh()"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                        <b-tooltip target="refresh" triggers="hover">
                                            Refresh
                                        </b-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<h1>Claim documents</h1>-->
        <div v-if="loading" class="text-center">
            <b-spinner label="Spinning"></b-spinner>
        </div>
        <b-list-group v-else>
            <b-list-group-item v-for="(itm,idx) in checkedUploadsDisplayOrder"
                               :key="'claim-uploads-' + idx"
                               href="#"
                               @click="rootToggle('example-collapse-' + idx)"
                               class="flex-column align-items-start"
                               :variant="determineGroupItemVariant(itm)">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{itm.documentTypeName}}</h5>
                    <small>{{itm.uploadedCount}} uploaded</small>
                </div>
                <b-collapse :id="'example-collapse-' + idx">
                    <ul v-if="itm.uploaded">
                        <li v-for="(docitm,docidx) in itm.uploads">{{docitm}}</li>
                    </ul>
                </b-collapse>
            </b-list-group-item>
        </b-list-group>
    </b-tab>
</template>
<script>

    import { documentApiService } from "@/services/document-api.service";

export default {
    name:'RequiredDocumentsCheck',
    props:{
        claimId: {
            type: Number,
            required: true
        }
    },
    data: () => {
        return {
            loading: false,
            checkedUploads: []
        }
        },
        beforeMount() {
            this.checkUploads(this.claimId)
        },
    computed: {
        checkedUploadsDisplayOrder() {
            return this.checkedUploads.sort((a,b) => {
                if (a.displayOrder > b.displayOrder)
                    return 1;
                else if (a.displayOrder < b.displayOrder)
                    return -1;

                return 0;
            })
        }
    },
        methods: {
            async checkUploads(claimId) {
                this.loading = true
                try {
                    var result = await documentApiService.checkUploaded(claimId)
                    this.checkedUploads = result.data || []
                } catch (err) {
                    console.error(err)
                }
                this.loading = false                
            },
            async refresh() {
                await this.checkUploads(this.claimId)
            },
        determineGroupItemVariant(itm) {
            if (itm.uploaded == true)
                return 'success'
            else
                return 'danger'

        },
        rootToggle(id) {
            this.$root.$emit('bv::toggle::collapse', id)
        }
    }
}
</script>